import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Descriptive, per-route document titles (WCAG 2.4.2 / SOP). Rendering this
// component (which returns null) inside the Router keeps document.title in
// sync with the current route without affecting any page logic or UI.
const TITLES: Record<string, string> = {
  "/": "Login",
  "/login": "Login",
  "/otp-login": "OTP Login",
  "/forget-password": "Forgot Password",
  "/reset-password": "Reset Password",
  "/dashboard": "Dashboard",
  "/user-management": "User Management",
  "/important-documents/add": "Add Document",
  "/role-management": "Role Management",
  "/sage-applications": "SAGE Applications",
  "/events": "Events",
  "/events/add": "Add Event",
  "/volunteers": "Volunteers",
  "/sage-homes": "SAGE Homes",
  "/sage-homes/add": "Add SAGE Home",
  "/assisted-devices": "Assisted Devices",
  "/assisted-devices/add": "Add Assisted Device",
  "/password-policy": "Password Policy",
};

const SUFFIX = "SCW Admin";

function titleFor(pathname: string): string {
  if (TITLES[pathname]) return TITLES[pathname];
  if (pathname.startsWith("/sage-applications/")) return "SAGE Application";
  if (pathname.startsWith("/events/edit/")) return "Edit Event";
  if (pathname.startsWith("/volunteers/")) return "Volunteer";
  if (pathname.startsWith("/sage-homes/edit/")) return "Edit SAGE Home";
  if (pathname.startsWith("/assisted-devices/edit/")) return "Edit Assisted Device";
  return "";
}

const RouteTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = titleFor(pathname);
    document.title = page ? `${page} | ${SUFFIX}` : SUFFIX;
  }, [pathname]);

  return null;
};

export default RouteTitle;
